var _defineProperty = require("/home/keoadmin/agent/_work/74/s/node_modules/@babel/runtime/helpers/defineProperty.js");
var _classCallCheck = require("/home/keoadmin/agent/_work/74/s/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/keoadmin/agent/_work/74/s/node_modules/@babel/runtime/helpers/createClass.js");
var _inherits = require("/home/keoadmin/agent/_work/74/s/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/home/keoadmin/agent/_work/74/s/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/keoadmin/agent/_work/74/s/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _wrapNativeSuper = require("/home/keoadmin/agent/_work/74/s/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var GraphQLError = /*#__PURE__*/function (_Error, _Symbol$toStringTag) {
  "use strict";

  _inherits(GraphQLError, _Error);
  var _super = _createSuper(GraphQLError);
  function GraphQLError(e, r, i, n, t, a, o) {
    var _this;
    _classCallCheck(this, GraphQLError);
    _this = _super.call(this, e);
    _this.name = "GraphQLError";
    _this.message = e;
    if (t) {
      _this.path = t;
    }
    if (r) {
      _this.nodes = Array.isArray(r) ? r : [r];
    }
    if (i) {
      _this.source = i;
    }
    if (n) {
      _this.positions = n;
    }
    if (a) {
      _this.originalError = a;
    }
    var l = o;
    if (!l && a) {
      var u = a.extensions;
      if (u && "object" == typeof u) {
        l = u;
      }
    }
    _this.extensions = l || {};
    return _this;
  }
  _createClass(GraphQLError, [{
    key: "toJSON",
    value: function toJSON() {
      return _objectSpread(_objectSpread({}, this), {}, {
        message: this.message
      });
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.message;
    }
  }, {
    key: _Symbol$toStringTag,
    get: function get() {
      return "GraphQLError";
    }
  }]);
  return GraphQLError;
}( /*#__PURE__*/_wrapNativeSuper(Error), Symbol.toStringTag);
var e;
var r;
function error(e) {
  return new GraphQLError("Syntax Error: Unexpected token at ".concat(r, " in ").concat(e));
}
function advance(i) {
  i.lastIndex = r;
  if (i.test(e)) {
    return e.slice(r, r = i.lastIndex);
  }
}
var i = new RegExp(" +(?=[^\\s])", "y");
function blockString(e) {
  var r = e.split("\n");
  var n = "";
  var t = 0;
  var a = 0;
  var o = r.length - 1;
  for (var l = 0; l < r.length; l++) {
    i.lastIndex = 0;
    if (i.test(r[l])) {
      if (l && (!t || i.lastIndex < t)) {
        t = i.lastIndex;
      }
      a = a || l;
      o = l;
    }
  }
  for (var u = a; u <= o; u++) {
    if (u !== a) {
      n += "\n";
    }
    n += r[u].slice(t).replace(/\\"""/g, '"""');
  }
  return n;
}
function ignored() {
  for (var i = 0 | e.charCodeAt(r++); 9 === i || 10 === i || 13 === i || 32 === i || 35 === i || 44 === i || 65279 === i; i = 0 | e.charCodeAt(r++)) {
    if (35 === i) {
      while (10 !== (i = e.charCodeAt(r++)) && 13 !== i) {}
    }
  }
  r--;
}
var n = new RegExp("[_A-Za-z]\\w*", "y");
function name() {
  var e;
  if (e = advance(n)) {
    return {
      kind: "Name",
      value: e
    };
  }
}
var t = new RegExp("(?:null|true|false)", "y");
var a = new RegExp("\\$[_A-Za-z]\\w*", "y");
var o = new RegExp("-?\\d+", "y");
var l = new RegExp("(?:\\.\\d+)?[eE][+-]?\\d+|\\.\\d+", "y");
var u = /\\/g;
var v = new RegExp("\"\"\"(?:\"\"\"|(?:[\\s\\S]*?[^\\\\])\"\"\")", "y");
var d = new RegExp("\"(?:\"|[^\\r\\n]*?[^\\\\]\")", "y");
function value(i) {
  var s;
  var c;
  if (c = advance(t)) {
    s = "null" === c ? {
      kind: "NullValue"
    } : {
      kind: "BooleanValue",
      value: "true" === c
    };
  } else if (!i && (c = advance(a))) {
    s = {
      kind: "Variable",
      name: {
        kind: "Name",
        value: c.slice(1)
      }
    };
  } else if (c = advance(o)) {
    var f = c;
    if (c = advance(l)) {
      s = {
        kind: "FloatValue",
        value: f + c
      };
    } else {
      s = {
        kind: "IntValue",
        value: f
      };
    }
  } else if (c = advance(n)) {
    s = {
      kind: "EnumValue",
      value: c
    };
  } else if (c = advance(v)) {
    s = {
      kind: "StringValue",
      value: blockString(c.slice(3, -3)),
      block: !0
    };
  } else if (c = advance(d)) {
    s = {
      kind: "StringValue",
      value: u.test(c) ? JSON.parse(c) : c.slice(1, -1),
      block: !1
    };
  } else if (s = function list(i) {
    var n;
    if (91 === e.charCodeAt(r)) {
      r++;
      ignored();
      var t = [];
      while (n = value(i)) {
        t.push(n);
      }
      if (93 !== e.charCodeAt(r++)) {
        throw error("ListValue");
      }
      ignored();
      return {
        kind: "ListValue",
        values: t
      };
    }
  }(i) || function object(i) {
    if (123 === e.charCodeAt(r)) {
      r++;
      ignored();
      var n = [];
      var t;
      while (t = name()) {
        ignored();
        if (58 !== e.charCodeAt(r++)) {
          throw error("ObjectField");
        }
        ignored();
        var a = value(i);
        if (!a) {
          throw error("ObjectField");
        }
        n.push({
          kind: "ObjectField",
          name: t,
          value: a
        });
      }
      if (125 !== e.charCodeAt(r++)) {
        throw error("ObjectValue");
      }
      ignored();
      return {
        kind: "ObjectValue",
        fields: n
      };
    }
  }(i)) {
    return s;
  }
  ignored();
  return s;
}
function arguments_(i) {
  var n = [];
  ignored();
  if (40 === e.charCodeAt(r)) {
    r++;
    ignored();
    var t;
    while (t = name()) {
      ignored();
      if (58 !== e.charCodeAt(r++)) {
        throw error("Argument");
      }
      ignored();
      var a = value(i);
      if (!a) {
        throw error("Argument");
      }
      n.push({
        kind: "Argument",
        name: t,
        value: a
      });
    }
    if (!n.length || 41 !== e.charCodeAt(r++)) {
      throw error("Argument");
    }
    ignored();
  }
  return n;
}
function directives(i) {
  var n = [];
  ignored();
  while (64 === e.charCodeAt(r)) {
    r++;
    var t = name();
    if (!t) {
      throw error("Directive");
    }
    ignored();
    n.push({
      kind: "Directive",
      name: t,
      arguments: arguments_(i)
    });
  }
  return n;
}
function field() {
  var i = name();
  if (i) {
    ignored();
    var n;
    if (58 === e.charCodeAt(r)) {
      r++;
      ignored();
      n = i;
      if (!(i = name())) {
        throw error("Field");
      }
      ignored();
    }
    return {
      kind: "Field",
      alias: n,
      name: i,
      arguments: arguments_(!1),
      directives: directives(!1),
      selectionSet: selectionSet()
    };
  }
}
function type() {
  var i;
  ignored();
  if (91 === e.charCodeAt(r)) {
    r++;
    ignored();
    var n = type();
    if (!n || 93 !== e.charCodeAt(r++)) {
      throw error("ListType");
    }
    i = {
      kind: "ListType",
      type: n
    };
  } else if (i = name()) {
    i = {
      kind: "NamedType",
      name: i
    };
  } else {
    throw error("NamedType");
  }
  ignored();
  if (33 === e.charCodeAt(r)) {
    r++;
    ignored();
    return {
      kind: "NonNullType",
      type: i
    };
  } else {
    return i;
  }
}
var s = new RegExp("on", "y");
function typeCondition() {
  if (advance(s)) {
    ignored();
    var e = name();
    if (!e) {
      throw error("NamedType");
    }
    ignored();
    return {
      kind: "NamedType",
      name: e
    };
  }
}
var c = new RegExp("\\.\\.\\.", "y");
function fragmentSpread() {
  if (advance(c)) {
    ignored();
    var e = r;
    var i;
    if ((i = name()) && "on" !== i.value) {
      return {
        kind: "FragmentSpread",
        name: i,
        directives: directives(!1)
      };
    } else {
      r = e;
      var n = typeCondition();
      var t = directives(!1);
      var a = selectionSet();
      if (!a) {
        throw error("InlineFragment");
      }
      return {
        kind: "InlineFragment",
        typeCondition: n,
        directives: t,
        selectionSet: a
      };
    }
  }
}
function selectionSet() {
  var i;
  ignored();
  if (123 === e.charCodeAt(r)) {
    r++;
    ignored();
    var n = [];
    while (i = fragmentSpread() || field()) {
      n.push(i);
    }
    if (!n.length || 125 !== e.charCodeAt(r++)) {
      throw error("SelectionSet");
    }
    ignored();
    return {
      kind: "SelectionSet",
      selections: n
    };
  }
}
var f = new RegExp("fragment", "y");
function fragmentDefinition() {
  if (advance(f)) {
    ignored();
    var e = name();
    if (!e) {
      throw error("FragmentDefinition");
    }
    ignored();
    var r = typeCondition();
    if (!r) {
      throw error("FragmentDefinition");
    }
    var i = directives(!1);
    var n = selectionSet();
    if (!n) {
      throw error("FragmentDefinition");
    }
    return {
      kind: "FragmentDefinition",
      name: e,
      typeCondition: r,
      directives: i,
      selectionSet: n
    };
  }
}
var p = new RegExp("(?:query|mutation|subscription)", "y");
function operationDefinition() {
  var i;
  var n;
  var t = [];
  var o = [];
  if (i = advance(p)) {
    ignored();
    n = name();
    t = function variableDefinitions() {
      var i;
      var n = [];
      ignored();
      if (40 === e.charCodeAt(r)) {
        r++;
        ignored();
        while (i = advance(a)) {
          ignored();
          if (58 !== e.charCodeAt(r++)) {
            throw error("VariableDefinition");
          }
          var t = type();
          var o = void 0;
          if (61 === e.charCodeAt(r)) {
            r++;
            ignored();
            if (!(o = value(!0))) {
              throw error("VariableDefinition");
            }
          }
          ignored();
          n.push({
            kind: "VariableDefinition",
            variable: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: i.slice(1)
              }
            },
            type: t,
            defaultValue: o,
            directives: directives(!0)
          });
        }
        if (41 !== e.charCodeAt(r++)) {
          throw error("VariableDefinition");
        }
        ignored();
      }
      return n;
    }();
    o = directives(!1);
  }
  var l = selectionSet();
  if (l) {
    return {
      kind: "OperationDefinition",
      operation: i || "query",
      name: n,
      variableDefinitions: t,
      directives: o,
      selectionSet: l
    };
  }
}
var m = {};
function printString(e) {
  return JSON.stringify(e);
}
function printBlockString(e) {
  return '"""\n' + e.replace(/"""/g, '\\"""') + '\n"""';
}
var hasItems = function hasItems(e) {
  return !(!e || !e.length);
};
var g = {
  OperationDefinition: function OperationDefinition(e) {
    if ("query" === e.operation && !e.name && !hasItems(e.variableDefinitions) && !hasItems(e.directives)) {
      return g.SelectionSet(e.selectionSet);
    }
    var r = e.operation;
    if (e.name) {
      r += " " + e.name.value;
    }
    if (hasItems(e.variableDefinitions)) {
      if (!e.name) {
        r += " ";
      }
      r += "(" + e.variableDefinitions.map(g.VariableDefinition).join(", ") + ")";
    }
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(g.Directive).join(" ");
    }
    return r + " " + g.SelectionSet(e.selectionSet);
  },
  VariableDefinition: function VariableDefinition(e) {
    var r = g.Variable(e.variable) + ": " + print(e.type);
    if (e.defaultValue) {
      r += " = " + print(e.defaultValue);
    }
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(g.Directive).join(" ");
    }
    return r;
  },
  Field: function Field(e) {
    var r = (e.alias ? e.alias.value + ": " : "") + e.name.value;
    if (hasItems(e.arguments)) {
      var i = e.arguments.map(g.Argument);
      var n = r + "(" + i.join(", ") + ")";
      r = n.length > 80 ? r + "(\n  " + i.join("\n").replace(/\n/g, "\n  ") + "\n)" : n;
    }
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(g.Directive).join(" ");
    }
    return e.selectionSet ? r + " " + g.SelectionSet(e.selectionSet) : r;
  },
  StringValue: function StringValue(e) {
    return e.block ? printBlockString(e.value) : printString(e.value);
  },
  BooleanValue: function BooleanValue(e) {
    return "" + e.value;
  },
  NullValue: function NullValue(e) {
    return "null";
  },
  IntValue: function IntValue(e) {
    return e.value;
  },
  FloatValue: function FloatValue(e) {
    return e.value;
  },
  EnumValue: function EnumValue(e) {
    return e.value;
  },
  Name: function Name(e) {
    return e.value;
  },
  Variable: function Variable(e) {
    return "$" + e.name.value;
  },
  ListValue: function ListValue(e) {
    return "[" + e.values.map(print).join(", ") + "]";
  },
  ObjectValue: function ObjectValue(e) {
    return "{" + e.fields.map(g.ObjectField).join(", ") + "}";
  },
  ObjectField: function ObjectField(e) {
    return e.name.value + ": " + print(e.value);
  },
  Document: function Document(e) {
    return hasItems(e.definitions) ? e.definitions.map(print).join("\n\n") : "";
  },
  SelectionSet: function SelectionSet(e) {
    return "{\n  " + e.selections.map(print).join("\n").replace(/\n/g, "\n  ") + "\n}";
  },
  Argument: function Argument(e) {
    return e.name.value + ": " + print(e.value);
  },
  FragmentSpread: function FragmentSpread(e) {
    var r = "..." + e.name.value;
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(g.Directive).join(" ");
    }
    return r;
  },
  InlineFragment: function InlineFragment(e) {
    var r = "...";
    if (e.typeCondition) {
      r += " on " + e.typeCondition.name.value;
    }
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(g.Directive).join(" ");
    }
    return r + " " + print(e.selectionSet);
  },
  FragmentDefinition: function FragmentDefinition(e) {
    var r = "fragment " + e.name.value;
    r += " on " + e.typeCondition.name.value;
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(g.Directive).join(" ");
    }
    return r + " " + print(e.selectionSet);
  },
  Directive: function Directive(e) {
    var r = "@" + e.name.value;
    if (hasItems(e.arguments)) {
      r += "(" + e.arguments.map(g.Argument).join(", ") + ")";
    }
    return r;
  },
  NamedType: function NamedType(e) {
    return e.name.value;
  },
  ListType: function ListType(e) {
    return "[" + print(e.type) + "]";
  },
  NonNullType: function NonNullType(e) {
    return print(e.type) + "!";
  }
};
function print(e) {
  return g[e.kind] ? g[e.kind](e) : "";
}
function valueFromASTUntyped(e, r) {
  switch (e.kind) {
    case "NullValue":
      return null;
    case "IntValue":
      return parseInt(e.value, 10);
    case "FloatValue":
      return parseFloat(e.value);
    case "StringValue":
    case "EnumValue":
    case "BooleanValue":
      return e.value;
    case "ListValue":
      var i = [];
      for (var n = 0, t = e.values; n < t.length; n += 1) {
        i.push(valueFromASTUntyped(t[n], r));
      }
      return i;
    case "ObjectValue":
      var a = Object.create(null);
      for (var o = 0, l = e.fields; o < l.length; o += 1) {
        var u = l[o];
        a[u.name.value] = valueFromASTUntyped(u.value, r);
      }
      return a;
    case "Variable":
      return r && r[e.name.value];
  }
}
exports.BREAK = m;
exports.GraphQLError = GraphQLError;
exports.Kind = {
  NAME: "Name",
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  DIRECTIVE: "Directive",
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType"
};
exports.OperationTypeNode = {
  QUERY: "query",
  MUTATION: "mutation",
  SUBSCRIPTION: "subscription"
};
exports.parse = function parse(i, n) {
  e = "string" == typeof i.body ? i.body : i;
  r = 0;
  return function document() {
    var e;
    ignored();
    var r = [];
    while (e = fragmentDefinition() || operationDefinition()) {
      r.push(e);
    }
    return {
      kind: "Document",
      definitions: r
    };
  }();
};
exports.parseType = function parseType(i, n) {
  e = "string" == typeof i.body ? i.body : i;
  r = 0;
  return type();
};
exports.parseValue = function parseValue(i, n) {
  e = "string" == typeof i.body ? i.body : i;
  r = 0;
  ignored();
  var t = value(!1);
  if (!t) {
    throw error("ValueNode");
  }
  return t;
};
exports.print = print;
exports.printBlockString = printBlockString;
exports.printString = printString;
exports.valueFromASTUntyped = valueFromASTUntyped;
exports.valueFromTypeNode = function valueFromTypeNode(e, r, i) {
  if ("Variable" === e.kind) {
    return i ? valueFromTypeNode(i[e.name.value], r, i) : void 0;
  } else if ("NonNullType" === r.kind) {
    return "NullValue" !== e.kind ? valueFromTypeNode(e, r, i) : void 0;
  } else if ("NullValue" === e.kind) {
    return null;
  } else if ("ListType" === r.kind) {
    if ("ListValue" === e.kind) {
      var n = [];
      for (var t = 0, a = e.values; t < a.length; t += 1) {
        var o = valueFromTypeNode(a[t], r.type, i);
        if (void 0 === o) {
          return;
        } else {
          n.push(o);
        }
      }
      return n;
    }
  } else if ("NamedType" === r.kind) {
    switch (r.name.value) {
      case "Int":
      case "Float":
      case "String":
      case "Bool":
        return r.name.value + "Value" === e.kind ? valueFromASTUntyped(e, i) : void 0;
      default:
        return valueFromASTUntyped(e, i);
    }
  }
};
exports.visit = function visit(e, r) {
  var i = [];
  var n = [];
  try {
    var t = function traverse(e, t, a) {
      var o = !1;
      var l = r[e.kind] && r[e.kind].enter || r[e.kind] || r.enter;
      var u = l && l.call(r, e, t, a, n, i);
      if (!1 === u) {
        return e;
      } else if (null === u) {
        return null;
      } else if (u === m) {
        throw m;
      } else if (u && "string" == typeof u.kind) {
        o = u !== e;
        e = u;
      }
      if (a) {
        i.push(a);
      }
      var v;
      var d = _objectSpread({}, e);
      for (var s in e) {
        n.push(s);
        var c = e[s];
        if (Array.isArray(c)) {
          var f = [];
          for (var p = 0; p < c.length; p++) {
            if (null != c[p] && "string" == typeof c[p].kind) {
              i.push(e);
              n.push(p);
              v = traverse(c[p], p, c);
              n.pop();
              i.pop();
              if (null == v) {
                o = !0;
              } else {
                o = o || v !== c[p];
                f.push(v);
              }
            }
          }
          c = f;
        } else if (null != c && "string" == typeof c.kind) {
          if (void 0 !== (v = traverse(c, s, e))) {
            o = o || c !== v;
            c = v;
          }
        }
        n.pop();
        if (o) {
          d[s] = c;
        }
      }
      if (a) {
        i.pop();
      }
      var g = r[e.kind] && r[e.kind].leave || r.leave;
      var h = g && g.call(r, e, t, a, n, i);
      if (h === m) {
        throw m;
      } else if (void 0 !== h) {
        return h;
      } else if (void 0 !== u) {
        return o ? d : u;
      } else {
        return o ? d : e;
      }
    }(e);
    return void 0 !== t && !1 !== t ? t : e;
  } catch (r) {
    if (r !== m) {
      throw r;
    }
    return e;
  }
};